export default __webpack_public_path__ + "static/media/logo.64fb898a.png";